(() => {
  'use strict';
  const init = () => {
    const header = document.querySelector('.gf-header');
    if (!header) return;
    const shell = header.closest('.shopify-section-group-header-group') ||
                  header.closest('.shopify-section') || header;
    shell.classList.add('gf-sticky-shell');
    const mobileMenu = header.querySelector('.gf-menu-mobile');
    const mobileBreakpoint = window.matchMedia('(max-width: 1249px)');
    const syncMobileMenu = () => document.documentElement.classList.toggle('gf-mobile-menu-open', !!mobileMenu?.open && mobileBreakpoint.matches);
    mobileMenu?.addEventListener('toggle', syncMobileMenu);
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && mobileMenu?.open) {
        mobileMenu.open = false;
        mobileMenu.querySelector('summary')?.focus();
      }
    });
    document.addEventListener('click', event => {
      if (mobileMenu?.open && !header.contains(event.target)) mobileMenu.open = false;
    });
    mobileBreakpoint.addEventListener?.('change', () => {
      if (!mobileBreakpoint.matches && mobileMenu?.open) mobileMenu.open = false;
      syncMobileMenu();
    });
    syncMobileMenu();
    const updateHeaderSurface = () => header.classList.toggle('gf-header--scrolled', window.scrollY > 16);
    updateHeaderSurface();
    window.addEventListener('scroll', updateHeaderSurface, {passive: true});
    // Keep the navigation visible while editing the unpublished theme.
    if (window.Shopify && window.Shopify.designMode) return;
    const menus = Array.from(header.querySelectorAll('details'));
    let lastY = Math.max(0, window.scrollY);
    let travel = 0;
    let direction = 0;
    let framePending = false;
    const show = () => shell.classList.remove('gf-header--hidden');
    const hide = () => {
      if (window.matchMedia('(max-width: 749px)').matches) return;
      shell.classList.add('gf-header--hidden');
    };
    const menuIsOpen = () => menus.some(menu => menu.open) || !!header.querySelector('[data-gf-inline-search] input:focus') || !!header.querySelector('[data-gf-search-results]:not([hidden])');
    const calculate = () => {
      framePending = false;
      const y = Math.max(0, window.scrollY);
      const change = y - lastY;
      lastY = y;
      if (y < 115 || menuIsOpen()) {
        show();
        travel = 0;
        direction = 0;
        return;
      }
      if (Math.abs(change) < 1) return;
      const nowDirection = change > 0 ? 1 : -1;
      if (direction !== nowDirection) travel = 0;
      direction = nowDirection;
      travel += Math.abs(change);
      if (direction > 0 && y > 170 && travel >= 16) {
        hide();
        travel = 0;
      } else if (direction < 0 && travel >= 10) {
        show();
        travel = 0;
      }
    };
    const onScroll = () => {
      if (framePending) return;
      framePending = true;
      window.requestAnimationFrame(calculate);
    };
    window.addEventListener('scroll', onScroll, {passive: true});
    window.addEventListener('resize', () => {
      updateHeaderSurface();
      lastY = Math.max(0, window.scrollY);
      travel = 0;
      show();
    }, {passive: true});
    menus.forEach(menu => menu.addEventListener('toggle', () => {
      if (menu.open) {
        travel = 0;
        show();
      }
    }));
    header.addEventListener('focusin', show);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, {once:true});
  } else {
    init();
  }
})();
